import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { label: 'ホーム', path: '/' },
  { label: 'サービス', path: '/services' },
  { label: '会社概要', path: '/about' },
  { label: 'お問い合わせ', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-[#1a2332] shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/8ef1e53c-6876-4560-8d78-c84b2466716a.png"
            alt="Y・F・S ロゴ"
            className="h-12 w-auto object-contain"
          />
          <span className="text-white font-semibold text-sm whitespace-nowrap tracking-wide">
            株式会社Y・F・S
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                location.pathname === item.path
                  ? 'text-white'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <Link
          to="/contact"
          className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer border border-white/40 text-white hover:bg-white hover:text-[#1a2332]"
        >
          お問合せ
        </Link>

        {/* Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-white"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium py-2 border-b border-gray-50 cursor-pointer ${
                location.pathname === item.path ? 'text-[#1a2332]' : 'text-gray-600'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 bg-[#1a2332] text-white text-sm font-medium px-5 py-3 rounded-full text-center whitespace-nowrap cursor-pointer"
          >
            お問合せ
          </Link>
        </div>
      )}
    </header>
  );
}
